import { ActivityState } from 'entities/lifecycle/activityState';
import { TFunction } from 'react-i18next';

export const campaignStateToTranslation = (state: ActivityState, t: TFunction<'campaigns'>) => {
  switch (state) {
    case 'Live':
      return t('campaignStates.live');
    case 'Testing':
      return t('campaignStates.testing');
    case 'Scheduled':
      return t('campaignStates.scheduled');
    case 'Paused':
      return t('campaignStates.paused');
    case 'Finished':
      return t('campaignStates.finished');
    case 'Archived':
      return t('campaignStates.archived');
    case 'Migration':
      return t('campaignStates.migration');
    default:
      return state;
  }
};
